<div class="container px-8 py-5 lg:py-8 mx-auto xl:px-5 max-w-screen-lg">

    <main>

      <div class="max-w-md mx-auto bg-white rounded-md shadow-md overflow-hidden md:max-w-2xl">

      <!-- <div class="max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden md:max-w-2xl"> -->
        <!-- <div class="md:flex">
          <div class="md:shrink-0">
            <img class="h-48 w-full object-cover md:h-full md:w-48" src="assets/building.jpg" alt="Modern building architecture">
          </div>
          <div class="p-8">
            <div class="uppercase tracking-wide text-sm text-indigo-500 font-semibold">Out now</div>
            <a href="#" class="block mt-1 text-lg leading-tight font-medium text-black hover:underline">Elements of Aerodynamics</a>
            <p class="mt-2 text-slate-500">An accessible and hands-on textbook filled with chapter objectives, examples, practice problems, sample tests, and an online aero-calculator.</p>
          </div>
        </div> -->
      </div>

      <br><br>

      <div class="grid gap-10 lg:gap-10 md:grid-cols-2">
        <mat-card>
          <mat-card-header> 
            <mat-card-title>
            <a href="https://patents.google.com/patent/US10605204B2/" target="_blank" class="cardTitle">United States Patent (2020)</a>
            </mat-card-title>
            <mat-card-subtitle>
              <!-- <a routerLink="/methoxy" class="cardSubtitle">Methane/Oxygen Rocket Engine</a> -->
              <a href="https://patents.google.com/patent/US10605204B2/" target="_blank" class="cardSubtitle">Methane/Oxygen Rocket Engine</a>
    
          </mat-card-subtitle>
        </mat-card-header>

          <mat-card-content>
            <p class="crop-text-4">
              An apparatus and method to enhance the performance of rockets engines which utilize liquid methane/oxygen pro-pellants by injecting optimized amounts of pressurized hot helium gas into the combustion chamber with the propellants. In one embodiment, the pressurized helium gas is stored at low temperatures near those of the cryogenic propellants and is used for regenerative cooling of the combustion chamber and nozzle during rocket operation in order to raise the temperature of the helium gas before being injected into the combustion chamber. 
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a href="https://patents.google.com/patent/US10605204B2/" target="_blank" class="cont">Continue reading</a>
    
          </mat-card-actions> 
        </mat-card>
      
        <mat-card>
          <mat-card-header> 
            <mat-card-title>
            <a routerLink="/gascalculator" class="cardTitle">Gasdynamics Calculator</a>
            </mat-card-title>
            <mat-card-subtitle>
              <a routerLink="/gascalculator" class="cardSubtitle">for Fundamentals of Gas Dynamics, 3rd ed.</a>
          </mat-card-subtitle>
    
          </mat-card-header>
          <mat-card-content>
            <p class="crop-text-4">
              This calculator reproduces Appendices G through J and calculates Oblique Shocks without the aid of the charts in Appendix D, having the Normal Shock formulations built-in. The user avoids any need for interpolation or extrapolation and further manipulations needed to arrive at the desired final answers are easily done with any standard calculators.
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a routerLink="/gascalculator" class="cont">Continue reading</a>
          </mat-card-actions>      
        </mat-card>
       
      
      </div>

<br><br>

      <div class="grid gap-10 lg:gap-10 md:grid-cols-2">
        <mat-card>
          <mat-card-header> 
            <mat-card-title>
              <a routerLink="/orbittransfer" class="cardTitle">Electric Propulsion in Space</a>
            </mat-card-title>
            <mat-card-subtitle>
              <a routerLink="/orbittransfer" class="cardSubtitle">Orbit Transfer Estimates</a>

    
          </mat-card-subtitle>
        </mat-card-header>

          <mat-card-content>
            <p class="crop-text-4">
              The work focuses on how to choose a most appropriate electric thruster given a space mission. 
              The relevant ideal flight formulation is enhanced by introducing a tankage mass fraction into the payload fraction equation. 
              An operating specific impulse is defined where the spacecraft's payload fraction and the thruster's propulsive time are jointly optimal for the mission. 
              Detailed information is given for choosing such 'dual optimum' given the change of vehicle velocity.
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a routerLink="/orbittransfer" class="cont">Continue reading</a>    
          </mat-card-actions> 
        </mat-card>
      
        <mat-card>
          <mat-card-header>
            <mat-card-title>
                <a routerLink="/ionthruster" class="cardTitle">Electric Propulsion in Space</a>
            </mat-card-title>
            <mat-card-subtitle>
                <a routerLink="/ionthruster" class="cardSubtitle">Beyond Maximum-Current Ion Thruster Limit</a>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p class="crop-text-4">
              The space charge limit from the (classical) Child-Langmuir law may be exceeded when the charged particles have initial injection velocities. 
              The relevant differential equation for both positive and negative charges is solved by exact analysis as well by numerical and asymptotic means.
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a routerLink="/ionthruster" class="cont">Continue reading</a>
            <!-- <button mat-button>Continue reading</button> -->
          </mat-card-actions>
        </mat-card>
       
      
      </div>


      <br><br>

      <div class="grid gap-10 lg:gap-10 md:grid-cols-2">
      
        <mat-card class="home-card">
          <mat-card-header> 
            <mat-card-title>
    
            <a routerLink="/realtoimag" class="cardTitle">Physical Formulations with Variables</a>
            
            </mat-card-title>
            <mat-card-subtitle>
              <a routerLink="/realtoimag" class="cardSubtitle">Transition from Real to Imaginary</a>
          </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p class="crop-text-4">
              In a number of physical problems, the formulations being solved may result in of one or more variables transitioning from real to imaginary within ranges of interest. Such transitions occur exclusively in nonlinear differential equations and can be opaque within numerical results unless the software has been set up to detect them.
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a routerLink="/realtoimag" class="cont">Continue reading</a>
          </mat-card-actions>
        </mat-card>
      
      </div>

    </main>


  </div>